import React from 'react'
import moment from 'utils/momentInstanse'

import WhiteBlockWraper from 'components/CommonUI/WhiteBlockWraper/WhiteBlockWraper'
import LogoGroup from 'components/LogoGroup/LogoGroup'
import TileInfo from 'components/TileInfo/TileInfo'
import Title from 'components/CommonUI/Title/Title'

const GroupInfoBlock = ({
  logoUrl = '',
  name = '',
  facylitiCount = '',
  monitoringSinceDate = 0,
}) => {
  const [first, last] = name.split(' ') || []

  const alt = `${first && first[0]}${(last && last[0]) || ''}`.toUpperCase()

  return (
    <WhiteBlockWraper className={'infocard_item_aside'}>
      <LogoGroup
        src={logoUrl}
        classNameContainer="infocard_item_logo"
        alternative={alt}
      />
      <Title title={name} component="h3" className="infocard_item_title" />
      <div className="infocard_item_tile_container">
        <TileInfo
          title="Tied facilities"
          content={facylitiCount}
          classNameContainer="overview-card-item"
        />
        <TileInfo
          title="Monitoring since"
          content={moment.unix(monitoringSinceDate).format('MMM DD, YYYY')}
        />
      </div>
    </WhiteBlockWraper>
  )
}

export default GroupInfoBlock
